import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GroupInfoDialogService } from '@interacta-shared/feature-member';
import { PaginatedList } from '@interacta-shared/util';
import {
    IUsersGroup,
    SearchPaginatedFilters,
} from '@interacta-shared/util-caronte';
import {
    genericWrapMemberPaginatedList,
    Member,
} from '@interacta-shared/util-member';
import { map, Observable } from 'rxjs';
import { UserCapabilitiesService } from './user-capabilites.service';
import { UsersService } from './users.service';

@Injectable()
export class CoreGroupInfoDialogService extends GroupInfoDialogService {
    private readonly userCapabilitiesService = inject(UserCapabilitiesService);
    private readonly usersService = inject(UsersService);

    constructor() {
        super();

        this.userCapabilitiesService.userCapabilities$
            .pipe(takeUntilDestroyed())
            .subscribe((capabilities) => {
                this.rootPermission.set(!!capabilities?.resellerAdmin);
                this.manageUsers.set(!!capabilities?.manageUsers);
            });
    }

    goToEditGroup(groupId?: IUsersGroup['id']): void {
        throw new Error('Method not implemented.');
    }

    fetchMembers(
        filters: { groupId: IUsersGroup['id'] },
        paginatedFilters?: SearchPaginatedFilters,
    ): Observable<PaginatedList<Member>> {
        const users = this.usersService.getGroupUsers(
            filters,
            paginatedFilters,
        );
        return users.pipe(map(genericWrapMemberPaginatedList));
    }
}
